// @ts-check

document.addEventListener("DOMContentLoaded", function () {
  const globalNavLarge = document.getElementById("global-nav-large");

  if (!globalNavLarge) {
    console.error('No `#global-nav-large` found.');
    return;
  }

  /** @type {NodeListOf<HTMLButtonElement>} */
  const menuDropdownToggles = globalNavLarge.querySelectorAll(
    ".global-nav__subnav-toggle"
  );

  const menus = Array.from(menuDropdownToggles).map((toggle) => {
    const panelId = toggle.getAttribute("aria-controls");
    if (!panelId) {
      console.error('Menu toggle has a missing or empty `aria-controls` property:');
      console.log(toggle);
      return;
    }

    const panel = document.getElementById(panelId);
    if (!panel) {
      console.error(`No menu-panel found with id '${panelId}'`);
      return;
    }

    return { toggle, panel };
  }).filter(menu => !!menu);

  /** @param {HTMLButtonElement} button */
  const isAriaExpanded = (button) => button.ariaExpanded === 'true';

  /**
   * Toggles open/closed state of menu. If moving to closed state,
   * will apply focus to toggle-button if focus was previously
   * inside the panel.
   * 
   * @param {HTMLButtonElement} button A DOM element for the menu's main toggle button
   * @param {HTMLElement} panel The panel that opens and closes
   * @param {boolean} [expanded] Whether the panel should be considered already expanded
   *                 or not. By default, the actual state will be determined by
   *                 checking the `aria-expanded` attribute on the button.
   */
  const toggleMenu = (button, panel, expanded) => {
    const activeElement = document.activeElement;

    if (expanded === undefined) {
      expanded = isAriaExpanded(button);
    }

    button.ariaExpanded = String(!expanded);
    panel.ariaHidden = String(!!expanded);

    // apply focus back to button if open panel contained active-element
    if (expanded && panel.contains(activeElement)) {
      button.focus();
    }
  };

  /**
   * Closes all open menus, except for an optional `menu`-object passed in.
   * @param {typeof menus[number]} [except]
   */
  const closeAllOpenPanels = (except) => {
    menus.forEach(menu => {
      if (menu === except) return;

      if (isAriaExpanded(menu.toggle)) {
        toggleMenu(menu.toggle, menu.panel, true);
      }
    });
  };

  // configure toggle-button and close-button behavior
  menus.forEach((menu) => {
    const closeButton = menu.panel.querySelector("button.panel-close");
    if (!(closeButton instanceof HTMLButtonElement)) {
      console.error('Menu-panel is missing a close-button');
      return;
    }

    closeButton.addEventListener("click", function () {
      toggleMenu(menu.toggle, menu.panel, true);
    });

    menu.toggle.addEventListener("click", function () {
      closeAllOpenPanels(menu);
      toggleMenu(menu.toggle, menu.panel);
    });
  });

  const globalHeader = document.getElementById('MainHeader');

  // just in case, use `globalNavLarge` as fallback
  const focusOutContainer = globalHeader || globalNavLarge;
  
  // when keyboard-focus leaves nav-region altogether, close any open subnav panels
  focusOutContainer.addEventListener('focusout', function (event) {
    const { relatedTarget } = event;
    if (!(relatedTarget instanceof Element)) return;

    // bail if `event.relatedTarget` is still inside the nav-region (except for search-button)
    if (focusOutContainer.contains(relatedTarget)) {
      if (!relatedTarget.closest('.search-button')) {
        return;
      }
    }

    closeAllOpenPanels();
  });

  // clicking outside open submenu panel (anywhere on page) auto-closes it
  document.addEventListener('click', function (event) {
    const { target } = event;
    if (!(target instanceof Element)) return;
  
    const containingMenu = menus.find(
      menu => menu.panel.contains(target) || menu.toggle.contains(target)
    );

    if (!containingMenu) {
      closeAllOpenPanels();
    }
  });

  // hitting Escape should close any open panels
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllOpenPanels();
    }
  });
  


  // MOBILE STUFF:

  const mobileDialogId = 'MobileNav';
  const mobileDialog = document.getElementById(mobileDialogId);
  if (!(mobileDialog instanceof HTMLDialogElement)) {
    console.error('No `dialog#MobileNav` element found');
    return;
  }

  // the breakpoint needs to match the one that triggers the desktop-nav to unhide (CSS)
  const breakpoint = window.matchMedia(`(min-width: ${1090/16}em)`);
  
  // close modal on desktop (we do this here INSTEAD OF in the CSS)
  breakpoint.addEventListener('change', (event) => {
    if (event.matches) {
      if (mobileDialog.open) {
        mobileDialog.close();
      }
    }
  });

  const mobileCloseButton = mobileDialog.querySelector('.panel-close');
  if (!(mobileCloseButton instanceof HTMLButtonElement)) {
    console.error('No `.panel-close` button found in `#MobileNav`.');
    return;
  }

  mobileCloseButton.addEventListener('click', () => {
    mobileDialog.close();
  });

  const mobileOpenButton = document.querySelector(`.menu-button`);
  if (!(mobileOpenButton instanceof HTMLButtonElement)) {
    console.error('No `.menu-button` button found.');
    return;
  }

  mobileOpenButton.ariaHasPopup = 'dialog';
  mobileOpenButton.setAttribute('aria-controls', mobileDialogId);

  mobileOpenButton.addEventListener('click', () => {
    mobileDialog.showModal();
  });
});
